import { debounce, throttle } from "lodash-es";
function Debounce(delay = 300) {
  return (target, prop) => {
    return {
      configurable: true,
      enumerable: false,
      value: debounce(target[prop], delay)
    };
  };
}
function Throttle(delay = 300, options) {
  return (target, prop) => {
    return {
      configurable: true,
      enumerable: false,
      value: throttle(target[prop], delay, options)
    };
  };
}
export {
  Debounce,
  Throttle
};
//# sourceMappingURL=index.es.js.map
